<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <span class="h5">
                    {{ titulo }}
                </span>
            </b-card-header>
            <b-card-body>
                <app-tabela
                    :itens="comprometimentos"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false"
                >
                    <template slot="botoes">
                        <slot name="botoes"></slot>
                    </template>
                    <template slot="valor" slot-scope="data">{{
                        data.valor | currency
                    }}</template>
                    <template
                        slot="selecao"
                        slot-scope="data"
                        v-if="incluirSelecao"
                    >
                        <slot name="selecao" v-bind="data"></slot>
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <slot name="comprometimentoAcoes" v-bind="data"></slot>
                        <comprometimento-anexos
                            :comprometimento="data"
                            :dataServico="pagamentosServicos"
                            :mostrarBtnInserir="false"
                            :mostrarBtnExcluir="false"
                        ></comprometimento-anexos>
                        <comprometimento-aprovadores
                            :comprometimento="data"
                            :dataServico="pagamentosServicos"
                        >
                        </comprometimento-aprovadores>
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import ComprometimentoAnexos from './../../comprometimentos/ComprometimentoAnexos'
import ComprometimentoAprovadores from './../../comprometimentos/ComprometimentoAprovadores'

export default {
    props: {
        comprometimentos: {
            type: Array,
            default: () => []
        },

        pagamentosServicos: {
            type: Object,
            default: () => {}
        },

        incluirSelecao: {
            type: Boolean,
            default: false
        },

        titulo: {
            type: String,
            default: 'SERVIÇOS'
        }
    },

    data() {
        return {
            campos: [
                {
                    key: 'acoes',
                    label: 'Ações'
                },
                {
                    key: 'idComprometimento',
                    label: 'Id',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'contrato',
                    label: 'Contrato',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'tipo',
                    label: 'Tipo',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap',
                    type: 'status'
                },
                {
                    key: 'processo',
                    label: 'Processo',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'dataEmissao',
                    label: 'Data de Emissão',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap text-center',
                    type: 'date'
                },
                {
                    key: 'dataMovimento',
                    label: 'Data do Movimento',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap text-center',
                    type: 'date'
                },
                {
                    key: 'historico',
                    label: 'Descritivo',
                    filterable: true
                },
                {
                    key: 'valor',
                    label: 'Valor',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'idRm',
                    label: 'ID RM',
                    tdClass: 'text-nowrap text-center'
                },
                {
                    key: 'situacao',
                    label: 'Situação',
                    type: 'status'
                },
                {
                    key: 'statusDescr',
                    label: 'Status',
                    type: 'status'
                },
                {
                    key: 'qtdAnexos',
                    label: 'Qtd. Anexos'
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime',
                    tdClass: 'text-nowrap text-center'
                }
            ],
            itensPorPagina: 10
        }
    },

    methods: {},

    created() {
        if (this.incluirSelecao) {
            this.campos.pop()
            this.campos.unshift({
                key: 'selecao',
                label: ''
            })
        }
    },

    computed: {},

    watch: {},

    components: {
        ComprometimentoAnexos,
        ComprometimentoAprovadores
    }
}
</script>
